import { Injectable, inject } from '@angular/core';
import { SiaReportPrintApi } from '../apis/sia-report-print.api';
import { SiaSessionParam } from '../interfaces/sia-session-param';
import { SiaNewRouterService } from './new-router.service';
import { notify } from './notify';
import { SiaSizeDetectorService } from './size-detector.service';

@Injectable({
  providedIn: 'root',
})
export class SiaReportPrintService {
  private reportApi = inject(SiaReportPrintApi);
  private routerService = inject(SiaNewRouterService);
  private sizeDetector = inject(SiaSizeDetectorService);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  downloadReport(
    params: {
      format?: string;
      reportName: string;
      reportParams: SiaSessionParam[];
    },
    fileName?: string,
  ) {
    if (!params?.reportName) {
      notify('Impossibile recuperare documento da scaricare. Nome report Nullo', 1500, 'error');
      return;
    }
    if (this.sizeDetector.currentSize.isMobile) {
      return this.saveReportAndNavigate(params);
    }
    return this.reportApi
      .downloadReport(params)
      .then((blob: Blob) => {
        const fileURL = URL.createObjectURL(blob);
        if (!fileURL) {
          notify('Impossibile recuperare documento da scaricare.', 1500, 'error');
          return;
        }
        if (blob.type && blob.type.toString() == 'application/pdf') {
          window.open(fileURL, '_blank');
        } else {
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = fileURL;
          a.download = fileName ?? params.reportName;
          a.click();
          window.URL.revokeObjectURL(fileURL);
          a.remove();
        }
      })
      .catch((e: any) => {
        console.error(e);
        notify('Impossibile recuperare documento da scaricare.', 1500, 'error');
      });
  }

  saveReportToPath(params: {
    reportName: string;
    reportParams: SiaSessionParam[];
    destinationPath: string;
    fileName?: string;
    mode?: 'pdf' | 'image';
  }): Promise<string | undefined> {
    if (!params?.reportName) {
      notify('Impossibile salvare il report. Nome report nullo', 1500, 'error');
      return Promise.resolve(undefined);
    }
    if (!params?.destinationPath) {
      notify('Impossibile salvare il report. Path di destinazione nullo', 1500, 'error');
      return Promise.resolve(undefined);
    }
    return this.reportApi
      .saveReportToPath({
        reportName: params.reportName,
        reportParams: params.reportParams,
        destinationPath: params.destinationPath,
        fileName: params.fileName,
        mode: params.mode ?? 'pdf',
      })
      .catch((e: any) => {
        console.error(e);
        notify('Impossibile salvare il report nel path indicato.', 1500, 'error');
        return undefined;
      });
  }

  saveReportAndNavigate(params: { format?: string; reportName: string; reportParams: SiaSessionParam[] }) {
    if (!params?.reportName) {
      notify('Impossibile recuperare documento da scaricare. Nome report Nullo', 1500, 'error');
      return;
    }

    return this.reportApi
      .saveReport(params)
      .then((path: string) => {
        this.routerService.navigateMenuWithParams('popup^pdf-viewer', [{ id: 'path', value: path }]);
      })
      .catch((e: any) => {
        console.error(e);
        notify('Impossibile recuperare documento da scaricare.', 1500, 'error');
      });
  }
}
